'use client'

import Animation from './animation'
import { useAboutPageContext } from '../../context'

const InjectHoverImages = () => {
    const { hoverImages } = useAboutPageContext()
    
    if (hoverImages.length > 0) {
        return (
            <Animation />
        )
    }
}

export default InjectHoverImages
